export const delay = 60 * 1000;
